module.exports = __webpack_public_path__ + "static/img/2.5bd3ebc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/2.png
// module id = nPba
// module chunks = 0